export function getValueFromCssVariable(varName: string): string {
  const style = getComputedStyle(document.querySelector(':root') || document.body);
  return style.getPropertyValue(varName.startsWith('--') ? varName : `--${varName}`);
}

/**
 * Reads a color token of the active theme, e.g. `getThemeColor('--danger')`. Read it when the color
 * is used, not when a module loads, so the color follows a theme switch.
 */
export function getThemeColor(token: string): string {
  return getValueFromCssVariable(token).trim();
}

/**
 * Reads a length token of the active theme in pixels, e.g. `getThemeLengthInPixels('--border-radius')`
 * for drawing on a canvas, which takes no rem. Returns `undefined` when the theme does not define it.
 */
export function getThemeLengthInPixels(token: string): number | undefined {
  const length = getValueFromCssVariable(token).trim();
  const lengthValue = Number.parseFloat(length);
  if (Number.isNaN(lengthValue)) {
    return undefined;
  }
  if (length.endsWith('rem')) {
    return lengthValue * Number.parseFloat(getComputedStyle(document.documentElement).fontSize);
  }
  return lengthValue;
}
